export const REQUEST_COMPANY_INVOICES_START = 'REQUEST_COMPANY_INVOICES_START';
export const REQUEST_COMPANY_INVOICES_COMPLETED = 'REQUEST_COMPANY_INVOICES_COMPLETED';
export const REQUEST_COMPANY_INVOICES_ERROR = 'REQUEST_COMPANY_INVOICES_ERROR';

export const getCompanyInvoices = companyId => {
    return {
        type: REQUEST_COMPANY_INVOICES_START,
        payload: { companyId }
    };
};

export const getCompanyInvoicesCompleted = invoices => {
    return {
        type: REQUEST_COMPANY_INVOICES_COMPLETED,
        payload: { invoices }
    };
};

export const getCompanyInvoicesError = error => {
    return {
        type: REQUEST_COMPANY_INVOICES_ERROR,
        error: error,
        payload: {}
    };
};
